import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EAlert, IAlertModalWarning, IAlertState, type TAlertButton } from '../../types/alert';
import { SliceActions } from '../types';

const initialState: IAlertState = {
  isVisible: false,
};

type TAlertPayload = {
  type?: EAlert;
  message?: string;
  chatId?: string;
  modalWarning?: IAlertModalWarning;
  button?: TAlertButton;
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert(state, action: PayloadAction<TAlertPayload>) {
      state.isVisible = true;

      if (action) {
        state.type = action.payload.type;
        state.message = action.payload.message;
        state.chatId = action.payload.chatId;
        state.modalWarning = action.payload.modalWarning;
        state.button = action.payload.button;
      }
    },
    hideAlert() {
      return initialState;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export const alertReducer = alertSlice.reducer;
export type TAlertActions = SliceActions<typeof alertSlice.actions>;
